import { ErrorBoundary } from '@/lib/error';
import { ErrorBanner } from '@/components/banner';
import { isRecordsLikeCell } from '@/core/cell';

import { useExplorationContext } from '@/explore/exploration/exploration-context';

import { useMetadataContext } from '@/explore/metadata-context';

import { Visualisation } from '../../types';
import { VisualisationPanel } from '../visualisation';
import { useExplorationCellContext } from '../../exploration/exploration-cell-context';
import { ensureValidVisualisation } from '../visualisation/utils';

import style from './visualisations.module.scss';

interface VisualisationsProps {
  visualisations: Visualisation[];
  onEditVisualisation?(index: number): void;
  isInView: boolean;
  isResized: boolean;
}

export const Visualisations = (props: VisualisationsProps) => {
  const { visualisations, onEditVisualisation } = props;

  const { exploration } = useExplorationContext();
  const { models, metrics } = useMetadataContext();

  const {
    cell,
    pipelineWithRollback,
    setVisualisation,
    removeVisualisation,
    isPipelinePreviewVisible,
  } = useExplorationCellContext();

  if (!isRecordsLikeCell(cell) || visualisations.length === 0) {
    return null;
  }

  const pipeline = pipelineWithRollback ?? cell.pipeline;

  return (
    <div className={style.visualisations}>
      {visualisations.map((visualisation, idx) => (
        <ErrorBoundary
          key={idx}
          fallback={(error) => <ErrorBanner description={(error as any).message} />}>
          <VisualisationPanel
            idx={idx}
            pipeline={pipeline}
            visualisation={ensureValidVisualisation(visualisation, {
              pipeline,
              exploration,
              models,
              metrics,
            })}
            onClose={() => removeVisualisation(idx)}
            onEdit={() => onEditVisualisation?.(idx)}
            onVisualisationChange={(visualisation) => setVisualisation(idx, visualisation)}
            isInView={props.isInView}
            isResized={props.isResized}
            hideHeader={!isPipelinePreviewVisible}
          />
        </ErrorBoundary>
      ))}
    </div>
  );
};
